import React from 'react'
import { Box, Button } from '@mui/material'
import { Edit, Save } from '@mui/icons-material'
import Tooltip from '../../common/Tooltip'

const AccordionHeader = ({
  hide,
  isEditing,
  setIsEditing,
  onSave,
  onCancel,
  additionalButtons = [],
  rightButtons = [],
  hideEdit,
  hideSave,
  hideCancel,
  canSave,
  hideRightButtons,
  saveDisabled = false,
  infoText,
}) => {
  return (
    <>
      {!hide && (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {additionalButtons.map((button, i) => {
                return (
                  <Button
                    key={i}
                    {...button}
                    sx={{ mr: 1, ...(button.sx || {}) }}
                  >
                    {button.label}
                  </Button>
                )
              })}
              {infoText && <Tooltip infoText={infoText} sx={{ ml: 1 }} />}
            </Box>
            <>
              <Box>
                {!hideEdit && !isEditing && (
                  <Button
                    variant={'outlined'}
                    onClick={() => setIsEditing(true)}
                    endIcon={<Edit />}
                  >
                    Edit
                  </Button>
                )}

                {!hideRightButtons && (
                  <>
                    {rightButtons.map((button, i) => {
                      return (
                        <Button sx={{ ml: 1 }} key={i} {...button}>
                          {button.label}
                        </Button>
                      )
                    })}
                  </>
                )}
              </Box>

              {isEditing && canSave && (
                <Box
                  key={canSave}
                  sx={{
                    display: 'flex',
                  }}
                >
                  <Box>
                    {!hideCancel && (
                      <Button
                        onClick={() => {
                          setIsEditing(false)
                          onCancel()
                        }}
                        sx={{ mr: 1, ml: 3 }}
                      >
                        Cancel
                      </Button>
                    )}
                    {!hideSave && (
                      <Button
                        disabled={saveDisabled}
                        color='primary'
                        variant='contained'
                        onClick={onSave}
                        endIcon={<Save />}
                      >
                        Save
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
            </>
          </Box>
        </>
      )}
    </>
  )
}

export default AccordionHeader
